import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { GRADING_MODAL } = ANALYTICS_CATEGORIES;

const { CLICK } = SNOWPLOW_EVENTS;

export const triggerGradingModalAccordionItemClosedByOtherEvent = (grade: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GRADING_MODAL,
		customData: { label: grade },
		name: 'dlr_grading_modal_accordion_item_closed_by_other',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
